import { GMAP_API_KEY, googleSheets } from "../../_js/common/_variables";
import {
    convertToClass,
    isEmpty,
    easeOutExpo,
    sanitize,
    removeFilterParams,
    removeDuplicates,
} from "../../_js/common/_util";
import MaterialDesign from "../../_js/common/_material-design";
import Filter from "../filter/filter";

("use strict");

export default class Map {
    constructor() {
        const self = this;

        self.param = "";
        self.cableArray = [];
        self.terrestrialCableArray = [];
        self.googleMarkersArr = [];
        self.googleUknownMarkersArr = [];
        self.markersArray = [];
        self.cablePath = [];
        self.terrestrialCablePath = [];
        self.landingPoint = [];

        self.$filterMsg = $(".filter .filter__msg");

        self.material = new MaterialDesign();
        self.filter = new Filter();

        window.aspi.googleMap = this;
    }

    buildMap(markersArray, unknownArray, param = null) {
        const self = this;
        const $map = $("#map");

        self.markersArray = markersArray;
        self.unknownArray = unknownArray;

        if (param !== null) {
            self.param = param;
            self.filter.disableCompany(param);
        }

        $(".-js-explore-map").on("click", function (e) {
            e.preventDefault();

            const $this = $(this);
            let btnMarkup = "";

            $map.toggleClass("-show");
            $this.toggleClass("-show");

            if ($this.hasClass("-show")) {
                btnMarkup = "Back to overview";
            } else {
                btnMarkup = '<span class="sr-only">Explore</span>Map';
            }

            $this.html(btnMarkup);
        });

        self.loadGoogleMap();
    }

    loadGoogleMap() {
        const self = this;

        if (!$("#gmap_js").length) {
            const script = document.createElement("script");
            const scriptStr =
                "https://maps.googleapis.com/maps/api/js?key=" +
                GMAP_API_KEY +
                "&callback=aspi.googleMap.initMap";

            script.setAttribute("id", "gmap_js");
            script.type = "text/javascript";
            script.src = scriptStr;
            script.async = "async";
            script.defer = "defer";
            document.body.appendChild(script);
        } else {
            self.initMap();
        }
    }

    initMap() {
        const self = this;

        let marker;
        let unknownMarker;

        const parser = new DOMParser();

        self.googleMarkersArr = [];
        self.googleUknownMarkersArr = [];
        self.infoWindow = new google.maps.InfoWindow();
        self.bounds = new google.maps.LatLngBounds();
        let startPoints = self.generateStartPoint();
        let startPointIndex = parseInt(Math.floor(Math.random() * 6));
        self.map = new google.maps.Map(document.getElementById("map"), {
            center: startPoints[startPointIndex].center,
            gestureHandling: "greedy",
            streetViewControl: false,
            mapTypeControl: false,
            minZoom: 2,
            zoom: startPoints[startPointIndex].zoom,
            styles: [
                {
                    featureType: "administrative",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: "-100",
                        },
                    ],
                },
                {
                    featureType: "administrative.country",
                    elementType: "geometry.stroke",
                    stylers: [
                        {
                            color: "#ebd7d9",
                        },
                    ],
                },
                {
                    featureType: "administrative.province",
                    elementType: "all",
                    stylers: [
                        {
                            visibility: "off",
                        },
                    ],
                },
                {
                    featureType: "landscape",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: -100,
                        },
                        {
                            lightness: 65,
                        },
                        {
                            visibility: "on",
                        },
                    ],
                },
                {
                    featureType: "landscape",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#fafaf8",
                        },
                    ],
                },
                {
                    featureType: "poi",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: -100,
                        },
                        {
                            lightness: "50",
                        },
                        {
                            visibility: "simplified",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: "-100",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "all",
                    stylers: [
                        {
                            visibility: "simplified",
                        },
                    ],
                },
                {
                    featureType: "road.arterial",
                    elementType: "all",
                    stylers: [
                        {
                            lightness: "30",
                        },
                    ],
                },
                {
                    featureType: "road.local",
                    elementType: "all",
                    stylers: [
                        {
                            lightness: "40",
                        },
                    ],
                },
                {
                    featureType: "transit",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: -100,
                        },
                        {
                            visibility: "simplified",
                        },
                    ],
                },
                {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [
                        {
                            lightness: -25,
                        },
                        {
                            saturation: -97,
                        },
                        {
                            color: "#d4dadc",
                        },
                    ],
                },
                {
                    featureType: "water",
                    elementType: "labels",
                    stylers: [
                        {
                            lightness: -25,
                        },
                        {
                            saturation: -100,
                        },
                    ],
                },
            ],
        });

        self.markersArray.forEach((el, i) => {
            let iconClass = convertToClass(el.type.class);
            let isHighlighted = el.isHighlighted;

            el.logo = "";
            if (typeof window.companyIndex != "undefined") {
                var companyName = null;
                if (
                    !isEmpty(el.type) &&
                    !isEmpty(el.type.label) &&
                    el.type.label == "Headquarters"
                ) {
                    if (!isEmpty(el.properties) && !isEmpty(el.properties[2])) {
                        companyName = el.properties[2].toLowerCase();
                    }
                } else {
                    if (!isEmpty(el.company)) {
                        companyName = el.company.toLowerCase();
                    }
                }

                if (
                    companyName != null &&
                    !isEmpty(window.companyIndex[companyName])
                ) {
                    el.logo = window.companyIndex[companyName];
                }
            }

            if (isEmpty(iconClass)) {
                return false;
            }

            marker = new google.maps.Marker({
                // animation: google.maps.Animation.DROP,
                category: iconClass,
                icon: {
                    url:
                        isHighlighted == true
                            ? `/assets/chi-tech/images/markers/highlighted-marker-${iconClass}.png`
                            : `/assets/chi-tech/images/markers/marker-${iconClass}.png`,
                    size:
                        isHighlighted == true
                            ? new google.maps.Size(46, 47)
                            : new google.maps.Size(20, 24),
                    origin: new google.maps.Point(0, 0),
                    anchor:
                        isHighlighted == true
                            ? new google.maps.Point(23, 40)
                            : new google.maps.Point(10, 24),
                },
                id: el.id,
                map: self.map,
                properties: el.properties,
                position: {
                    lat: Number(el.country.lat),
                    lng: Number(el.country.long),
                },
                title: el.label,
                zIndex: isHighlighted == true ? 10 : 5,
            });

            self.googleMarkersArr.push(marker);

            // Allow each marker to have an info window
            let infoContent = `<div class="infoWindow">`;

            if (isHighlighted) {
                infoContent += `    <div class="infoWindow__header -highlighted">`;
            } else {
                infoContent += `    <div class="infoWindow__header">`;
            }

            infoContent += `        <div class="infoWindow__iconTypeDetails -${iconClass}">`;
            infoContent += `            <div class="infoWindow__iconType -${iconClass}">`;
            infoContent += `                <div class="infoWindow__icon -${iconClass}"></div>`;
            infoContent += `                <div class="infoWindow__type">${el.type.label}</div>`;
            infoContent += `            </div>`;

            infoContent += `<div class="infoWindow__details">`;

            infoContent +=
                isEmpty(el.label) !== true
                    ? `<div class="infoWindow__program"><div>Label</div><div> ${el.label}</div></div>`
                    : "";

            if (!isEmpty(el.type.year)) {
                infoContent += `            <div class="infoWindow__year"><div>Year</div><div> ${el.type.year}</div></div>`;
            }

            if (!isEmpty(el.country.label)) {
                
                    infoContent += `        <div class="infoWindow__country"><div>Country</div><div> ${el.country.label}</div></div>`;
                
            }

            if (!isEmpty(el.owner)) {
                infoContent += `            <div class="infoWindow__program"><div>Owned By</div><div>  ${el.owner}</div></div>`;
            }


            infoContent += `            </div>`;
            infoContent += `        </div>`;

            if (window.location.hash.indexOf("map") > -1) {
                infoContent += `            <div class="infoWindow__logoWrapper"><div class="sidebar__logo" href="#/company/${sanitize(
                    companyName
                )}">${
                    el.logo
                }</div><button class="infoWindow__btn -js-view-company" data-link="#/company/${sanitize(
                    el.company
                )}" type="button">${el.company}</button></div>`;
            }

            infoContent += `     </div>`;
            infoContent += `     <div class="infoWindow__deeplinkBody">`;
            infoContent += `         <div class="infoWindow__deeplink">
                                        <button class="infoWindow__btn -js-copy-deeplink" type="button">Click here to copy a link to this marker</button>
                                        <input id="deeplink" class="sr-only" type="text" value="${
                                            window.location.origin +
                                            "/#/map/marker-" +
                                            el.id
                                        }" />
                                    </div>
                                    <div class="infoWindow__body">
                                        <p>${el.text}</p>
                                    </div>
                                </div>`;
            infoContent += `     </div>`;

            google.maps.event.addListener(
                marker,
                "click",
                (function (marker, i) {
                    return function () {
                        self.infoWindow.setContent(infoContent);
                        self.infoWindow.open(self.map, marker);

                        // Just so to attach the class
                        setTimeout(() => {
                            if (isHighlighted) {
                                $(".gm-ui-hover-effect").addClass("-alt");
                                $(".gm-style-iw-t").addClass("-highlighted");
                            }
                            // $('.gm-style-iw')
                            //     .prev().addClass('gm-style-prev').end()
                            //     .next().addClass('gm-style-btn');
                        }, 25);
                    };
                })(marker, i)
            );
        });

        if (self.unknownArray != undefined) {


            self.unknownArray.forEach((el, i) => {
                
                let unknownInfoContent =``;

                el.markersArr.forEach((em, j) => {
                    let iconClass = convertToClass(em.type.class);

                    if (typeof window.companyIndex != "undefined") {
                        var companyName = null;
                        if (
                            !isEmpty(em.type) &&
                            !isEmpty(em.type.label) &&
                            em.type.label == "Headquarters"
                        ) {
                            if (
                                !isEmpty(em.properties) &&
                                !isEmpty(em.properties[2])
                            ) {
                                companyName = em.properties[2].toLowerCase();
                            }
                        } else {
                            if (!isEmpty(em.company)) {
                                companyName = em.company.toLowerCase();
                            }
                        }

                        if (
                            companyName != null &&
                            !isEmpty(window.companyIndex[companyName])
                        ) {
                            em.logo = window.companyIndex[companyName];
                        }
                    }
                    
                    unknownInfoContent += `<div class="infoWindow -unknown">`;
                    unknownInfoContent += `         <div class="infoWindow__header">
                                                    <div class="infoWindow__iconTypeDetails -${iconClass}">`;
                    unknownInfoContent += `            <div class="infoWindow__iconType -${iconClass}">`;
                    unknownInfoContent += `                <div class="infoWindow__icon -${iconClass}"></div>`;
                    unknownInfoContent += `                 <div class="infoWindow__type">${em.type.label}</div>`;
                    unknownInfoContent += `            </div>`;

                    unknownInfoContent += `<div class="infoWindow__details">`;

                    unknownInfoContent +=
                        isEmpty(em.label) !== true
                            ? `<div class="infoWindow__program"><div>Label</div><div> ${em.label}</div></div>`
                            : "";

                    if (!isEmpty(em.type.year)) {
                        unknownInfoContent += `            <div class="infoWindow__year"><div>Year</div><div> ${em.type.year}</div></div>`;
                    }

                    if (!isEmpty(el.country.label)) {
                        if (el.country.label != null) {
                            unknownInfoContent += `        <div class="infoWindow__country"><div>Country</div><div> ${el.country.label}</div></div>`;
                        }
                    }

                    unknownInfoContent += `        <div class="infoWindow__country"><div>Unknown location</div><div>
                                                        <div class="infoWindow__help">
                                                         <button class="infoWindow__btn -js-help" type="button" title="We were not able to locate precise coordinates for this location.">What does this mean?</button>
                                                        </div></div></div>
                                                    </div>`;

                    unknownInfoContent += `            </div>`;

                    if (window.location.hash.indexOf("map") > -1) {
                        unknownInfoContent += `            <div class="infoWindow__logoWrapper"><div class="sidebar__logo" href="#/company/${sanitize(
                            companyName
                        )}">${
                            em.logo
                        }</div><button class="infoWindow__btn -js-view-company" data-link="#/company/${sanitize(
                            em.company
                        )}" type="button">${em.company}</button></div>`;
                    }

                    unknownInfoContent += `        </div>`;
                    // end of TypeIconDetails
                    //add the collapse function

                    

                   

                    unknownInfoContent += `     <div class="infoWindow__deeplinkBody">`;
                    unknownInfoContent +=  `<button class="infoWindow__toggle -js-toggle-info" type="button">
                    <span class="infoWindow__status">Open</span></button>` ;
                    unknownInfoContent += `         <div class="infoWindow__deeplink">

                                                        <div class="infoWindow__detail" style="display:none">
                                                            <p>${em.text}</p>
                                                        </div>`;
                    unknownInfoContent += `         </div>`;
                    unknownInfoContent += `     </div>`;
                    unknownInfoContent += ` </div>`;
                    unknownInfoContent += `</div>`;
                });


                unknownMarker = new google.maps.Marker({
                    // animation: google.maps.Animation.DROP,
                    id: el.id,
                    icon: {
                        url: `/assets/chi-tech/images/markers/marker-unknown.png`,
                        size: new google.maps.Size(15, 15),
                        scaledSize: new google.maps.Size(15, 15),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(7.5, 7.5),
                    },
                    map: self.map,
                    position: {
                        lat: el.country.lat,
                        lng: el.country.long,
                    },
                    properties: el.properties,
                    title: el.country.label,
                    zIndex: 10,
                });

                self.googleUknownMarkersArr.push(unknownMarker);

                google.maps.event.addListener(
                    unknownMarker,
                    "click",
                    (function (unknownMarker, i) {
                        return function () {
                            self.infoWindow.setContent(unknownInfoContent);
                            self.infoWindow.open(self.map, unknownMarker);

                            $(
                                ".infoWindow .infoWindow__item:first-child .-js-toggle-info"
                            ).trigger("click");

                            // Just so to attach the class
                            setTimeout(() => {
                                $(".gm-style-iw")
                                    .prev()
                                    .addClass("gm-style-prev")
                                    .end()
                                    .next()
                                    .addClass("gm-style-btn");
                            }, 25);
                        };
                    })(unknownMarker, i)
                );
            });
        }

        if (self.cableArray !== undefined) {
            let cablePath = "";
            let landingPoint = "";

            self.cableArray.forEach((el, ind) => {
                const xmlDoc = parser.parseFromString(el.routes, "text/xml");
                let coordArr = [];

                $(xmlDoc)
                    .find("LineString")
                    .each((i, v) => {
                        let newCoordArr = [];

                        coordArr = $(v).find("coordinates")[0].innerHTML;
                        coordArr = coordArr.split(" ");

                        coordArr.forEach((coorArrEl, ind) => {
                            coordArr[ind] = coorArrEl.split(",");

                            if (i == 0 && el.isHighlighted) {
                                marker = new google.maps.Marker({
                                    // animation: google.maps.Animation.DROP,
                                    category: "cable",
                                    icon: {
                                        url: "/assets/chi-tech/images/markers/highlighted-marker-cable-terrestrial.png",
                                        size: new google.maps.Size(46, 47),
                                        origin: new google.maps.Point(0, 0),
                                        anchor: new google.maps.Point(23, 40),
                                    },
                                    id: `cable-marker-${el.id}`,
                                    map: self.map,
                                    properties: el.properties,
                                    position: {
                                        lng: Number(coordArr[i][0]),
                                        lat: Number(coordArr[i][1]),
                                    },
                                    title: el.label,
                                    zIndex: 10,
                                });

                                self.googleMarkersArr.push(marker);

                                google.maps.event.addListener(
                                    marker,
                                    "click",
                                    (function (marker, i) {
                                        return function () {
                                            self.toggleCableOpacity(el);

                                            let infoContent = `                   <div class="infoWindow">`;

                                            if (el.isHighlighted) {
                                                infoContent += `                        <div class="infoWindow__header -highlighted">`;
                                            } else {
                                                infoContent += `                        <div class="infoWindow__header">`;
                                            }

                                            if (
                                                typeof window.companyIndex !=
                                                "undefined"
                                            ) {
                                                var companyName = null;
                                                if (
                                                    !isEmpty(el.type) &&
                                                    !isEmpty(el.type.label) &&
                                                    el.type.label ==
                                                        "Headquarters"
                                                ) {
                                                    if (
                                                        !isEmpty(
                                                            el.properties
                                                        ) &&
                                                        !isEmpty(
                                                            el.properties[2]
                                                        )
                                                    ) {
                                                        companyName =
                                                            el.properties[2].toLowerCase();
                                                    }
                                                } else {
                                                    if (!isEmpty(el.company)) {
                                                        companyName =
                                                            el.company.toLowerCase();
                                                    }
                                                }

                                                if (
                                                    companyName != null &&
                                                    !isEmpty(
                                                        window.companyIndex[
                                                            companyName
                                                        ]
                                                    )
                                                ) {
                                                    el.logo =
                                                        window.companyIndex[
                                                            companyName
                                                        ];
                                                }
                                            }

                                            infoContent += `        <div class="infoWindow__iconTypeDetails -cable">`;
                                            infoContent += `            <div class="infoWindow__iconType -cable">`;
                                            infoContent += `                <div class="infoWindow__icon -cable"></div>`;
                                            infoContent += `                 <div class="infoWindow__type">Cable</div>`;
                                            infoContent += `            </div>`;

                                            infoContent += `<div class="infoWindow__details">`;

                                            if (!isEmpty(el.name) ){    
                                                infoContent +=
                                                    `<div class="infoWindow__program"><div>Label</div><div> ${el.name}</div></div>`
                                            }
                                                infoContent += `</div>`;
                                            if (!isEmpty(el.rfs)) {
                                                infoContent += `            <div class="infoWindow__year"><div>RFS</div><div>  ${el.rfs}</div></div>`;
                                            }
                                            if (!isEmpty(el.owner)) {
                                                infoContent += `            <div class="infoWindow__program"><div>Owned By</div><div>  ${el.owner}</div></div>`;
                                            }
                                                infoContent += `            </div>`;

                                            if (
                                                window.location.hash.indexOf(
                                                    "map"
                                                ) > -1
                                            ) {
                                                infoContent += `            <div class="infoWindow__logoWrapper"><div class="sidebar__logo" href="#/company/${sanitize(
                                                    companyName
                                                )}">${
                                                    el.logo
                                                }</div><button class="infoWindow__btn -js-view-company" data-link="#/company/${sanitize(
                                                    el.company
                                                )}" type="button">${
                                                    el.company
                                                }</button></div>`;
                                            }

                                            infoContent += `        </div>`;
                                            // end of TypeIconDetails

                                            infoContent += `    <div class="infoWindow__deeplinkBody">`;
                                            infoContent += `         <div class="infoWindow__deeplink">
                                                                         <button class="infoWindow__btn -js-copy-deeplink" type="button">Click here to copy a link to this marker</button>
                                                                            <input id="deeplink" class="sr-only" type="text" value="${window.location.origin + "/#/map/marker-" + el.id }" />
                                                                        </div>

                                                                <div class="infoWindow__body">
                                                                    <p>${el.text}</p>
                                                                </div>`;
                                            infoContent += `         </div>`;
                                            infoContent += `     </div>`;
                                            infoContent += ` </div>`;
                                            infoContent += `</div>`;
                                            // end of markup

                                            self.infoWindow.setContent(
                                                infoContent
                                            );
                                            self.infoWindow.open(
                                                self.map,
                                                marker
                                            );

                                            // Just so to attach the class
                                            setTimeout(() => {
                                                if (el.isHighlighted) {
                                                    $(
                                                        ".gm-ui-hover-effect"
                                                    ).addClass("-alt");
                                                    $(
                                                        ".gm-style-iw-t"
                                                    ).addClass("-highlighted");
                                                }
                                                // $('.gm-style-iw')
                                                //     .prev().addClass('gm-style-prev').end()
                                                //     .next().addClass('gm-style-btn');
                                            }, 25);
                                        };
                                    })(marker, i)
                                );
                            }
                        });

                        coordArr.forEach((el, i) => {
                            newCoordArr.push({
                                lng: Number(el[0]),
                                lat: Number(el[1]),
                            });
                        });

                        if (el.isHighlighted) {
                            cablePath = new google.maps.Polyline({
                                id: el.id,
                                // icons: [
                                //     {
                                //         icon: {
                                //             path: "M 0,-1 0,1",
                                //             strokeOpacity: 1,
                                //             scale: 3,
                                //         },
                                //         offset: "0",
                                //         repeat: "20px",
                                //     },
                                // ],
                                isHighlighted: el.isHighlighted,
                                geodesic: true,
                                map: self.map,
                                name: el.name,
                                path: newCoordArr,
                                properties: el.properties,
                                strokeColor: el.color,
                                strokeOpacity: 1.0,
                                visible: true,
                            });
                        } else {
                            cablePath = new google.maps.Polyline({
                                id: el.id,
                                isHighlighted: el.isHighlighted,
                                geodesic: true,
                                map: self.map,
                                name: el.name,
                                path: newCoordArr,
                                properties: el.properties,
                                strokeColor: el.color,
                                strokeOpacity: 1.0,
                                strokeWeight: 3,
                                visible: true,
                            });
                        }

                        // Dim other cables
                        google.maps.event.addListener(
                            cablePath,
                            "click",
                            function (path) {
                                self.toggleCableOpacity(el);

                                let infoContent = `                   <div class="infoWindow">`;

                                if (el.isHighlighted) {
                                    infoContent += `                        <div class="infoWindow__header -highlighted">`;
                                } else {
                                    infoContent += `                        <div class="infoWindow__header">`;
                                }

                                if (typeof window.companyIndex != "undefined") {
                                    var companyName = null;
                                    if (
                                        !isEmpty(el.type) &&
                                        !isEmpty(el.type.label) &&
                                        el.type.label == "Headquarters"
                                    ) {
                                        if (
                                            !isEmpty(el.properties) &&
                                            !isEmpty(el.properties[2])
                                        ) {
                                            companyName =
                                                el.properties[2].toLowerCase();
                                        }
                                    } else {
                                        if (!isEmpty(el.company)) {
                                            companyName =
                                                el.company.toLowerCase();
                                        }
                                    }

                                    if (
                                        companyName != null &&
                                        !isEmpty(
                                            window.companyIndex[companyName]
                                        )
                                    ) {
                                        el.logo =
                                            window.companyIndex[companyName];
                                    }
                                }

                                infoContent += `        <div class="infoWindow__iconTypeDetails -cable">`;
                                infoContent += `            <div class="infoWindow__iconType -cable">`;
                                infoContent += `                <div class="infoWindow__icon -cable"></div>`;
                                infoContent += `                 <div class="infoWindow__type">${el.name}</div>`;
                                infoContent += `            </div>`;

                                infoContent += `<div class="infoWindow__details">`;

                                infoContent +=
                                    isEmpty(el.owner) !== true
                                        ? `<div class="infoWindow__program"><div>Owned By</div><div class="cable"> ${el.owner}</div></div>`
                                        : "";
                                //remove the leased by on map/cables
                                // if (!isEmpty(el.lease)) {
                                //     infoContent += `            <div class="infoWindow__year"><div>Leased By:</div><div> ${el.lease}</div></div>`;
                                // }
                                if (!isEmpty(el.rfs)) {
                                    infoContent += `            <div class="infoWindow__year"><div>RFS</div><div>  ${el.rfs}</div></div>`;
                                }

                              

                                infoContent += `               </div>`;
                                infoContent += `            </div>`;

                                if (window.location.hash.indexOf("map") > -1) {
                                    infoContent += `            <div class="infoWindow__logoWrapper"><div class="sidebar__logo" href="#/company/${sanitize(
                                        companyName
                                    )}">${
                                        el.logo
                                    }</div><button class="infoWindow__btn -js-view-company" data-link="#/company/${sanitize(
                                        el.company
                                    )}" type="button">${
                                        el.company
                                    }</button></div>`;
                                }

                                infoContent += `        </div>`;
                                // end of TypeIconDetails

                                infoContent += `     <div class="infoWindow__deeplinkBody">`;
                                infoContent += `         <div class="infoWindow__deeplink">

                                                                    <div class="infoWindow__body">
                                                                        <p>${el.text}</p>
                                                                    </div>`;
                                infoContent += `         </div>`;
                                infoContent += `     </div>`;
                                infoContent += ` </div>`;
                                infoContent += `</div>`;
                                // end of markup

                                // infoContent += `       </div>
                                //             </div>`;

                                let cableMarker = new google.maps.Marker({
                                    icon: {
                                        size: new google.maps.Size(0, 0),
                                        url: "/assets/chi-tech/images/markers/marker-landing-point.png",
                                    },
                                    position: new google.maps.LatLng(
                                        path.latLng.lat(),
                                        path.latLng.lng()
                                    ),
                                    map: self.map,
                                });

                                self.infoWindow.setContent(infoContent);
                                self.infoWindow.open(self.map, cableMarker);
                            }
                        );

                        self.cablePath.push(cablePath);
                    });

                // Drop Landing point markers
                el.points.forEach((em, i) => {
                    let latlon = em.latlon.split(",");

                    landingPoint = new google.maps.Marker({
                        id: el.id,
                        icon: {
                            size: new google.maps.Size(8, 8),
                            scaledSize: new google.maps.Size(8, 8),
                            origin: new google.maps.Point(0, 0),
                            anchor: new google.maps.Point(4, 4),
                            url: "/assets/chi-tech/images/markers/marker-landing-point.png",
                        },
                        map: self.map,
                        position: {
                            lat: Number(latlon[0]),
                            lng: Number(latlon[1]),
                        },
                        properties: el.properties,
                        zIndex: 1,
                    });

                    self.landingPoint.push(landingPoint);
                });
            });
        }

        if (self.terrestrialCableArray !== undefined) {
            let terrestrialCablePath = "";
            let landingPoint = "";

            self.terrestrialCableArray.forEach((el, ind) => {
                const xmlDoc = parser.parseFromString(el.routes, "text/xml");
                let coordArr = [];

                $(xmlDoc)
                    .find("LineString")
                    .each((i, v) => {
                        let newCoordArr = [];

                        coordArr = $(v).find("coordinates")[0].innerHTML;
                        coordArr = coordArr.split(" ");

                        coordArr.forEach((coorArrEl, ind) => {
                            coordArr[ind] = coorArrEl.split(",");

                            if (i == 0 && el.isHighlighted) {
                                marker = new google.maps.Marker({
                                    // animation: google.maps.Animation.DROP,
                                    category: "cable-terrestrial",
                                    icon: {
                                        url: "/assets/chi-tech/images/markers/highlighted-marker-cable-terrestrial.png",
                                        size: new google.maps.Size(46, 47),
                                        origin: new google.maps.Point(0, 0),
                                        anchor: new google.maps.Point(23, 40),
                                    },
                                    id: `cable-terrestrial-marker-${el.id}`,
                                    map: self.map,
                                    properties: el.properties,
                                    position: {
                                        lng: Number(coordArr[i][0]),
                                        lat: Number(coordArr[i][1]),
                                    },
                                    title: el.label,
                                    zIndex: 10,
                                });
                                self.googleMarkersArr.push(marker);

                                google.maps.event.addListener(
                                    marker,
                                    "click",
                                    (function (marker, i) {
                                        return function () {
                                            self.toggleCableOpacity(el);

                                            let infoContent = `                   <div class="infoWindow">`;

                                            if (el.isHighlighted) {
                                                infoContent += `                        <div class="infoWindow__header -highlighted">`;
                                            } else {
                                                infoContent += `                        <div class="infoWindow__header">`;
                                            }

                                            if (
                                                typeof window.companyIndex !=
                                                "undefined"
                                            ) {
                                                var companyName = null;
                                                if (
                                                    !isEmpty(el.type) &&
                                                    !isEmpty(el.type.label) &&
                                                    el.type.label ==
                                                        "Headquarters"
                                                ) {
                                                    if (
                                                        !isEmpty(
                                                            el.properties
                                                        ) &&
                                                        !isEmpty(
                                                            el.properties[2]
                                                        )
                                                    ) {
                                                        companyName =
                                                            el.properties[2].toLowerCase();
                                                    }
                                                } else {
                                                    if (!isEmpty(el.company)) {
                                                        companyName =
                                                            el.company.toLowerCase();
                                                    }
                                                }

                                                if (
                                                    companyName != null &&
                                                    !isEmpty(
                                                        window.companyIndex[
                                                            companyName
                                                        ]
                                                    )
                                                ) {
                                                    el.logo =
                                                        window.companyIndex[
                                                            companyName
                                                        ];
                                                }
                                            }

                                            infoContent += `        <div class="infoWindow__iconTypeDetails -cable">`;
                                            infoContent += `            <div class="infoWindow__iconType -cable">`;
                                            infoContent += `                <div class="infoWindow__icon -cable"></div>`;
                                            infoContent += `                 <div class="infoWindow__type">${el.name}</div>`;
                                            infoContent += `            </div>`;

                                            infoContent += `<div class="infoWindow__details">`;

                                            infoContent +=
                                                isEmpty(el.owner) !== true
                                                    ? `<div class="infoWindow__program"><div>Owned By</div><div> ${el.owner}</div></div>`
                                                    : "";
                                            if (!isEmpty(el.rfs)) {
                                                infoContent += `            <div class="infoWindow__year"><div>RFS</div><div>  ${el.rfs}</div></div>`;
                                             }

                                            if (!isEmpty(el.lease)) {
                                                infoContent += `            <div class="infoWindow__year"><div>Leased By:</div><div> ${el.lease}</div></div>`;
                                            }

                                            infoContent += `               </div>`;
                                            infoContent += `            </div>`;

                                            if (
                                                window.location.hash.indexOf(
                                                    "map"
                                                ) > -1
                                            ) {
                                                infoContent += `            <div class="infoWindow__logoWrapper"><div class="sidebar__logo" href="#/company/${sanitize(
                                                    companyName
                                                )}">${
                                                    el.logo
                                                }</div><button class="infoWindow__btn -js-view-company" data-link="#/company/${sanitize(
                                                    el.company
                                                )}" type="button">${
                                                    el.company
                                                }</button></div>`;
                                            }

                                            infoContent += `        </div>`;
                                            // end of TypeIconDetails

                                            infoContent += `     <div class="infoWindow__deeplinkBody">`;
                                            infoContent += `         <div class="infoWindow__deeplink">

                                                                                <div class="infoWindow__body">
                                                                                    <p>${el.text}</p>
                                                                                </div>`;
                                            infoContent += `         </div>`;
                                            infoContent += `     </div>`;
                                            infoContent += ` </div>`;
                                            infoContent += `</div>`;
                                            // end of markup

                                            if (
                                                !isEmpty(el.owner) ||
                                                !isEmpty(el.lease)
                                            ) {
                                                infoContent += `                            <div class="infoWindow__body">`;
                                                if (!isEmpty(el.owner)) {
                                                    infoContent += `                            <div class="infoWindow__row">Owned By <div>${el.owner}</div></div>`;
                                                }
                                                if (!isEmpty(el.rfs)) {
                                                    infoContent += `            <div class="infoWindow__year"><div>RFS</div><div>  ${el.rfs}</div></div>`;
                                                }

                                                if (!isEmpty(el.lease)) {
                                                    infoContent += `                            <div class="infoWindow__row"><strong>Leased By:</strong> ${el.lease}</div>`;
                                                }

                                                infoContent += `                            </div>`;
                                            }

                                            // if (!isEmpty(el.text)) {
                                            //     infoContent += `        <div class="infoWindow__text">${el.text}</div>`;
                                            // }

                                            infoContent += `       </div>
                                                        </div>`;

                                            self.infoWindow.setContent(
                                                infoContent
                                            );
                                            self.infoWindow.open(
                                                self.map,
                                                marker
                                            );

                                            // Just so to attach the class
                                            setTimeout(() => {
                                                if (el.isHighlighted) {
                                                    $(
                                                        ".gm-ui-hover-effect"
                                                    ).addClass("-alt");
                                                    $(
                                                        ".gm-style-iw-t"
                                                    ).addClass("-highlighted");
                                                }
                                                // $('.gm-style-iw')
                                                //     .prev().addClass('gm-style-prev').end()
                                                //     .next().addClass('gm-style-btn');
                                            }, 25);
                                        };
                                    })(marker, i)
                                );
                            }
                        });

                        coordArr.forEach((el, i) => {
                            newCoordArr.push({
                                lng: Number(el[0]),
                                lat: Number(el[1]),
                            });
                        });

                        if (el.isHighlighted) {
                            terrestrialCablePath = new google.maps.Polyline({
                                id: el.id,
                                // icons: [
                                //     {
                                //         icon: {
                                //             path: "M 0,-1 0,1",
                                //             strokeOpacity: 1,
                                //             scale: 3,
                                //         },
                                //         offset: "0",
                                //         repeat: "20px",
                                //     },
                                // ],
                                isHighlighted: el.isHighlighted,
                                geodesic: true,
                                map: self.map,
                                name: el.name,
                                path: newCoordArr,
                                properties: el.properties,
                                strokeColor: el.color,
                                strokeOpacity: 0.25,
                                visible: true,
                            });
                        } else {
                            terrestrialCablePath = new google.maps.Polyline({
                                id: el.id,
                                isHighlighted: el.isHighlighted,
                                geodesic: true,
                                map: self.map,
                                name: el.name,
                                path: newCoordArr,
                                properties: el.properties,
                                strokeColor: el.color,
                                strokeOpacity: 1.0,
                                strokeWeight: 3,
                                visible: true,
                            });
                        }

                        // Dim other cables
                        google.maps.event.addListener(
                            terrestrialCablePath,
                            "click",
                            function (path) {
                                self.toggleCableOpacity(el);

                                let infoContent = `                   <div class="infoWindow">`;

                                if (el.isHighlighted) {
                                    infoContent += `                        <div class="infoWindow__header -highlighted">`;
                                } else {
                                    infoContent += `                        <div class="infoWindow__header">`;
                                }
                                let iconClass = "cable";

                                if (typeof window.companyIndex != "undefined") {
                                    var companyName = null;
                                    if (
                                        !isEmpty(el.type) &&
                                        !isEmpty(el.type.label) &&
                                        el.type.label == "Headquarters"
                                    ) {
                                        if (
                                            !isEmpty(el.properties) &&
                                            !isEmpty(el.properties[2])
                                        ) {
                                            companyName =
                                                el.properties[2].toLowerCase();
                                        }
                                    } else {
                                        if (!isEmpty(el.company)) {
                                            companyName =
                                                el.company.toLowerCase();
                                        }
                                    }

                                    if (
                                        companyName != null &&
                                        !isEmpty(
                                            window.companyIndex[companyName]
                                        )
                                    ) {
                                        el.logo =
                                            window.companyIndex[companyName];
                                    }
                                }

                                infoContent += `        <div class="infoWindow__iconTypeDetails -${iconClass}">`;
                                infoContent += `            <div class="infoWindow__iconType -${iconClass}">`;
                                infoContent += `                <div class="infoWindow__icon -${iconClass}"></div>`;
                                infoContent += `                 <div class="infoWindow__type">${el.name}</div>`;
                                infoContent += `            </div>`;

                                infoContent += `<div class="infoWindow__details">`;

                                infoContent +=
                                    isEmpty(el.owner) !== true
                                        ? `<div class="infoWindow__program"><div>Owned By</div><div> ${el.owner}</div></div>`
                                        : "";
                                if (!isEmpty(el.rfs)) {
                                    infoContent += `            <div class="infoWindow__year"><div>RFS</div><div>  ${el.rfs}</div></div>`;
                                }

                                if (!isEmpty(el.lease)) {
                                    infoContent += `            <div class="infoWindow__year"><div>Leased By:</div><div> ${el.lease}</div></div>`;
                                }

                                infoContent += `               </div>`;
                                infoContent += `            </div>`;

                                if (window.location.hash.indexOf("map") > -1) {
                                    infoContent += `            <div class="infoWindow__logoWrapper"><div class="sidebar__logo" href="#/company/${sanitize(
                                        companyName
                                    )}">${
                                        el.logo
                                    }</div><button class="infoWindow__btn -js-view-company" data-link="#/company/${sanitize(
                                        el.company
                                    )}" type="button">${
                                        el.company
                                    }</button></div>`;
                                }

                                infoContent += `        </div>`;
                                // end of TypeIconDetails

                                infoContent += `     <div class="infoWindow__deeplinkBody">`;
                                infoContent += `         <div class="infoWindow__deeplink">

                                                                    <div class="infoWindow__body" >
                                                                        <p>${el.text}</p>
                                                                    </div>`;
                                infoContent += `         </div>`;
                                infoContent += `     </div>`;
                                infoContent += ` </div>`;
                                infoContent += `</div>`;
                                // end of markup

                                let cableMarker = new google.maps.Marker({
                                    icon: {
                                        size: new google.maps.Size(0, 0),
                                        scaledSize: new google.maps.Size(0, 0),
                                        url: "/assets/chi-tech/images/markers/marker-landing-point.png",
                                    },
                                    position: new google.maps.LatLng(
                                        path.latLng.lat(),
                                        path.latLng.lng()
                                    ),
                                    map: self.map,
                                });

                                self.infoWindow.setContent(infoContent);
                                self.infoWindow.open(self.map, cableMarker);
                            }
                        );

                        self.terrestrialCablePath.push(terrestrialCablePath);
                    });

                // Drop Landing point markers
                el.points.forEach((em, i) => {
                    let latlon = em.latlon.split(",");

                    landingPoint = new google.maps.Marker({
                        id: el.id,
                        icon: {
                            size: new google.maps.Size(8, 8),
                            scaledSize: new google.maps.Size(8, 8),
                            origin: new google.maps.Point(0, 0),
                            anchor: new google.maps.Point(4, 4),
                            url: "/assets/chi-tech/images/markers/marker-landing-point.png",
                        },
                        map: self.map,
                        position: {
                            lat: Number(latlon[0]),
                            lng: Number(latlon[1]),
                        },
                        properties: el.properties,
                        zIndex: 1,
                    });

                    self.landingPoint.push(landingPoint);
                });
            });
        }

        // Dim all cables
        self.initializeCableOpacity();

        // Highlight all cables
        google.maps.event.addListener(self.map, "click", function () {
            self.initializeCableOpacity();
            self.infoWindow.close();
        });

        // Event listener for filter on Map page
        $("body")
            .on("click", ".-js-toggle-info", function (e) {
                e.preventDefault();

                const $this = $(this);
                const $details = $this.parent().find(".infoWindow__detail");
                const $body = $this.closest(".infoWindow__body");

                if ($this.hasClass("-active")) {
                    $this
                        .removeClass("-active")
                        .find(".infoWindow__status")
                        .text("Open");
                    $details.slideUp(easeOutExpo);
                } else {
                    $body
                        .find(".-active")
                        .removeClass("-active")
                        .end()
                        .find(".infoWindow__status")
                        .text("Open")
                        .end()
                        .find(".infoWindow__detail")
                        .stop()
                        .clearQueue()
                        .slideUp(easeOutExpo);

                    $this
                        .addClass("-active")
                        .find(".infoWindow__status")
                        .text("Close");

                    $details.stop().clearQueue().slideDown(easeOutExpo);
                }
            })
            .on("click", ".-js-view-company", function (e) {
                e.preventDefault();

                window.location.href = $(this).data("link");
            })
            .on("click", ".-js-copy-deeplink", function (e) {
                let copyText = document.getElementById("deeplink");
                copyText.select();
                document.execCommand("copy");

                self.material.toaster(
                    "The link has been copied to your clipboard."
                );
            });
    }


    setOverseasPresenceModel(obj) {
        this.overseasPresenceModel = obj;
    }

    setCableModel(arr) {
        this.cableArray = arr;
    }

    setTerrestrialCableModel(arr) {
        this.terrestrialCableArray = arr;
    }

    createQueryString(array, isDataListing = false) {
        let query = "";
        let fbomb0 = false;
        let fbomb1 = [];
        let fbomb2 = [];
        let fbomb3 = [];
        let fbomb4 = [];
        let fbomb5 = [];
        let fbomb6 = [];

        array.forEach((el, i) => {
            // Highlighted
            if (el.indexOf("f0-") > -1) {
                removeFilterParams(el);
                fbomb0 = true;
            }

            // Country
            if (el.indexOf("f1-") > -1) {
                fbomb1.push(removeFilterParams(el));
            }

            // Company
            if (el.indexOf("f2-") > -1) {
                fbomb2.push(removeFilterParams(el));
            }

            // Type of company
            if (el.indexOf("f3-") > -1) {
                fbomb3.push(removeFilterParams(el));
            }

            // Ownership structure
            if (el.indexOf("f4-") > -1) {
                fbomb4.push(removeFilterParams(el));
            }

            // Overseas Presence
            if (el.indexOf("f5-") > -1) {
                fbomb5.push(removeFilterParams(el));
            }

            // Topics
            if (el.indexOf("f6-") > -1) {
                fbomb6.push(removeFilterParams(el));
            }
        });

        if (isDataListing) {
            if (array.length > 0) {
                query =
                    "select A, B, C, D, E, F, G, H, I, J, K, L, M, N, O, P, Q, R, S, T, U, V, W, X, Y, Z where ";
            } else {
                query = "select A, B, C, D, E, F, G, H, I, J, K, L, M, N, O, P, Q, R, S, T, U, V, W, X, Y, Z ";
            }
        } else {
            if (array.length > 0) {
                query = "select A, P, V, B, C, D where ";
            } else {
                query = "select A, P, V, B, C, D ";
            }
        }

        if (fbomb1.length > 0) {
            query += "(";
        }

        fbomb1.forEach((el, i) => {
            let _el = el;

            if (_el == "Guinea") {
                _el = "83 | Guinea";

                if (fbomb1.length > 0 && i == 0) {
                    query += `((E = "${_el}") `;
                } else if (fbomb1.length > 1 && i > 0) {
                    query += ` or (E = "${_el}") `;
                }
            } else {
                if (fbomb1.length > 0 && i == 0) {
                    query += `((E contains "${_el}") `;
                } else if (fbomb1.length > 1 && i > 0) {
                    query += ` or (E contains "${_el}") `;
                }
            }

            query = query.trim();

            if (i == fbomb1.length - 1) {
                query += ") ";
            }
        });

        fbomb1.forEach((el, i) => {
            let _el = el;

            if (_el == "Guinea") {
                _el = "83 | Guinea";

                if (fbomb1.length > 0 && i == 0) {
                    query += `or ((V = "${_el}") `;
                } else if (fbomb1.length > 1 && i > 0) {
                    query += ` or (V = "${_el}") `;
                }
            } else {
                if (fbomb1.length > 0 && i == 0) {
                    query += `or ((V contains "${_el}") `;
                } else if (fbomb1.length > 1 && i > 0) {
                    query += ` or (V contains "${_el}") `;
                }
            }

            query = query.trim();

            if (i == fbomb1.length - 1) {
                query += ") ";
            }
        });

        if (fbomb1.length > 0) {
            query += ")";
        }

        fbomb2.forEach((el, i) => {
            if (fbomb1.length == 0 && i == 0) {
                query += `(B contains "${el}" `;
            } else if ((fbomb1.length > 0 || fbomb2.length > 0) && i == 0) {
                query += ` and (B contains "${el}"`;
            } else if ((fbomb1.length > 0 || fbomb2.length > 0) && i > 0) {
                query += ` or B contains "${el}" `;
            }

            query = query.trim();

            if (i == fbomb2.length - 1) {
                query += ") ";
            }
        });

        fbomb3.forEach((el, i) => {
            if (fbomb1.length == 0 && fbomb2.length == 0 && i == 0) {
                query += `(T contains "${el}" `;
            } else if (
                (fbomb1.length > 0 || fbomb2.length > 0 || fbomb3.length > 0) &&
                i == 0
            ) {
                query += ` and (T contains "${el}"`;
            } else if (
                (fbomb1.length > 0 || fbomb2.length > 0 || fbomb3.length > 0) &&
                i > 0
            ) {
                query += ` or T contains "${el}" `;
            }

            query = query.trim();

            if (i == fbomb3.length - 1) {
                query += ") ";
            }
        });

        fbomb4.forEach((el, i) => {
            if (
                fbomb1.length == 0 &&
                fbomb2.length == 0 &&
                fbomb3.length == 0 &&
                i == 0
            ) {
                query += `(U contains "${el}" `;
            } else if (
                (fbomb1.length > 0 ||
                    fbomb2.length > 0 ||
                    fbomb3.length > 0 ||
                    fbomb4.length > 0) &&
                i == 0
            ) {
                query += ` and (U contains "${el}"`;
            } else if (
                (fbomb1.length > 0 ||
                    fbomb2.length > 0 ||
                    fbomb3.length > 0 ||
                    fbomb4.length > 0) &&
                i > 0
            ) {
                query += ` or U contains "${el}" `;
            }

            query = query.trim();

            if (i == fbomb4.length - 1) {
                query += ") ";
            }
        });

        fbomb5.forEach((el, i) => {
            let _el = el;

            if (_el == "Cable") {
                _el = "2 | Cable";
            } else if (_el == "Cable (leased)") {
                _el = "19 | Cable (leased)";
            } else if (_el == "Cable Terrestrial") {
                _el = "13 | Cable Terrestrial";
            }

            if (
                _el == "Cable" ||
                _el == "Cable (leased)" ||
                _el == "Cable Terrestrial"
            ) {
                if (
                    fbomb1.length == 0 &&
                    fbomb2.length == 0 &&
                    fbomb3.length == 0 &&
                    fbomb4.length == 0 &&
                    i == 0
                ) {
                    query += `((C = "${_el}" or D = "${_el}") `;
                } else if (
                    (fbomb1.length > 0 ||
                        fbomb2.length > 0 ||
                        fbomb3.length > 0 ||
                        fbomb4.length > 0 ||
                        fbomb5.length > 0) &&
                    i == 0
                ) {
                    query += ` and ((C = "${_el}" or D = "${_el}")`;
                } else if (
                    (fbomb1.length > 0 ||
                        fbomb2.length > 0 ||
                        fbomb3.length > 0 ||
                        fbomb4.length > 0 ||
                        fbomb5.length > 0) &&
                    i > 0
                ) {
                    query += ` or (C = "${_el}" or D = "${_el}") `;
                }
            } else {
                if (
                    fbomb1.length == 0 &&
                    fbomb2.length == 0 &&
                    fbomb3.length == 0 &&
                    fbomb4.length == 0 &&
                    i == 0
                ) {
                    query += `((C contains "${_el}" or D contains "${_el}") `;
                } else if (
                    (fbomb1.length > 0 ||
                        fbomb2.length > 0 ||
                        fbomb3.length > 0 ||
                        fbomb4.length > 0 ||
                        fbomb5.length > 0) &&
                    i == 0
                ) {
                    query += ` and ((C contains "${_el}" or D contains "${_el}")`;
                } else if (
                    (fbomb1.length > 0 ||
                        fbomb2.length > 0 ||
                        fbomb3.length > 0 ||
                        fbomb4.length > 0 ||
                        fbomb5.length > 0) &&
                    i > 0
                ) {
                    query += ` or (C contains "${_el}" or D contains "${_el}") `;
                }
            }

            query = query.trim();

            if (i == fbomb5.length - 1) {
                query += ") ";
            }
        });

        fbomb6.forEach((el, i) => {
            if (
                fbomb1.length == 0 &&
                fbomb2.length == 0 &&
                fbomb3.length == 0 &&
                fbomb4.length == 0 &&
                fbomb5.length == 0 &&
                i == 0
            ) {
                query += `((L contains "${el}" or M contains "${el}" or N contains "${el}") `;
            } else if (
                (fbomb1.length > 0 ||
                    fbomb2.length > 0 ||
                    fbomb3.length > 0 ||
                    fbomb4.length > 0 ||
                    fbomb5.length > 0 ||
                    fbomb6.length > 0) &&
                i == 0
            ) {
                query += ` and ((L contains "${el}" or M contains "${el}" or N contains "${el}")`;
            } else if (
                (fbomb1.length > 0 ||
                    fbomb2.length > 0 ||
                    fbomb3.length > 0 ||
                    fbomb4.length > 0 ||
                    fbomb5.length > 0 ||
                    fbomb6.length > 0) &&
                i > 0
            ) {
                query += ` or (L contains "${el}" or M contains "${el}" or N contains "${el}") `;
            }

            query = query.trim();

            if (i == fbomb6.length - 1) {
                query += ") ";
            }
        });

        if (fbomb0) {
            if (
                fbomb1.length > 0 ||
                fbomb2.length > 0 ||
                fbomb3.length > 0 ||
                fbomb4.length > 0 ||
                fbomb5.length > 0 ||
                fbomb6.length > 0
            ) {
                query += `and (Q = TRUE) `;
            } else {
                query += `(Q = TRUE) `;
            }

            query = query.trim();
        }

        // * START Placeholder for searching keywords in the data sheet
        // if (keyword) {
        //     if (
        //         fbomb1.length > 0 ||
        //         fbomb2.length > 0 ||
        //         fbomb3.length > 0 ||
        //         fbomb4.length > 0 ||
        //         fbomb5.length > 0 ||
        //         fbomb6.length > 0
        //     ) {
        //         query += ` and (B contains "${keyword}" or C contains "${keyword}" or D contains "${keyword}" or E contains "${keyword}" or I contains "${keyword}" or J contains "${keyword}" or L contains "${keyword}" or M contains "${keyword}" or N contains "${keyword}" or O contains "${keyword}")`;
        //     } else {
        //         query += ` (B contains "${keyword}" or C contains "${keyword}" or D contains "${keyword}" or E contains "${keyword}" or I contains "${keyword}" or J contains "${keyword}" or L contains "${keyword}" or M contains "${keyword}" or N contains "${keyword}" or O contains "${keyword}")`;
        //     }
        // }
        // * END Placeholder for searching keywords in the data sheet

        // console.log(query);

        query = encodeURIComponent(query.trim());

        return query;
    }

    filterMap(array, isDataListing = false) {
        const self = this;

        if (!isDataListing) {
            self.bounds = new google.maps.LatLngBounds();

            // Reset all markers to be visible
            self.resetMarkers();

            // Hide opened info windows
            self.infoWindow.close();
        }

        let query = self.createQueryString(array, false);
        let _url = `https://docs.google.com/spreadsheets/d/${googleSheets.urlID}/gviz/tq?tqx=out:json&gid=1003963993&tq=${query}`;

        query = self.createQueryString(array, true);
        let _linkURL = `https://docs.google.com/spreadsheets/d/${googleSheets.urlID}/gviz/tq?tqx=out:csv&gid=1003963993&tq=${query}`;

        $(".download-results-btn").attr("href", _linkURL);

        $.ajax({
            url: _url,
            success: function (res) {
                let data = res;

                data = data.replace("/*O_o*/", "");
                data = data.replace(
                    "google.visualization.Query.setResponse(",
                    ""
                );
                data = data.substring(0, data.length - 2);
                data = JSON.parse(data);

                if (data.table.rows.length == 0) {
                    self.displayResultNumber(0);
                    self.material.toaster(
                        "There are no results found.  Try a different search query."
                    );
                    return false;
                }

                data = data.table.rows;

                // Set markers visible/hidden on filter
                data.forEach((el, i) => {
                    self.cablePath.forEach((em, i) => {
                        if (el.c[0] !== null && em.id == el.c[0].v) {
                            em.setVisible(true);
                        }
                    });

                    self.terrestrialCablePath.forEach((em, i) => {
                        if (el.c[0] !== null && em.id == el.c[0].v) {
                            em.setVisible(true);
                        }
                    });

                    self.landingPoint.forEach((em, i) => {
                        if (el.c[0] !== null && em.id == el.c[0].v) {
                            em.setVisible(true);
                        }
                    });

                    self.googleMarkersArr.forEach((em, i) => {
                        if (
                            el.c[0] !== null &&
                            em.id == el.c[0].v &&
                            em.category !== "cable"
                        ) {
                            em.setVisible(true);
                        }

                        if (
                            el.c[0] !== null &&
                            em.id == `cable-marker-${el.c[0].v}`
                        ) {
                            em.setVisible(true);
                        }

                        if (
                            el.c[0] !== null &&
                            em.id == `cable-terrestrial-marker-${el.c[0].v}`
                        ) {
                            em.setVisible(true);
                        }
                    });

                    self.googleUknownMarkersArr.forEach((em, i) => {
                        em.id.forEach((en, i) => {
                            if (el.c[0] !== null && en == el.c[0].v) {
                                em.setVisible(true);
                            }
                        });
                    });
                });

                // This is for map filtering
                let dataPointCount = 0;
                data.forEach((dataElem) => {
                    if (
                        dataElem.c[4] !== "null" &&
                        !isEmpty(dataElem.c[4]) &&
                        dataElem.c[5] !== "null" &&
                        !isEmpty(dataElem.c[5])
                    ) {
                        dataPointCount += 1;
                    }
                });

                self.displayResultNumber(dataPointCount);

                // self.map.fitBounds(self.bounds);
                self.map.setZoom(self.map.getZoom() - 3);

                self.filter.toggleFilters(data, self.overseasPresenceModel);
            },
            error: function (err) {
                console.error(err);
            },
        });
        if (array.length == 0) {
            self.displayAllMarkers();
        } else {
        }
    }

    displayResultNumber(number) {
        $(".data-results-number").html(number);
    }

    toggleCableOpacity(el) {
        this.cablePath.forEach((em, i) => {
            em.setOptions({ strokeOpacity: 0.25 });

            if (em.name == el.name) {
                em.setOptions({ strokeOpacity: 1 });

                // if (em.isHighlighted) {
                //     em.setOptions({ strokeOpacity: 0 });
                // } else {
                //     em.setOptions({ strokeOpacity: 1 });
                // }
            }
        });

        this.terrestrialCablePath.forEach((em, i) => {
            em.setOptions({
                strokeOpacity: 0.25,
                // icons: [
                //     {
                //         icon: {
                //             path: "M 0,-1 0,1",
                //             strokeOpacity: 0.25,
                //             scale: 3,
                //         },
                //         offset: "0",
                //         repeat: "20px",
                //     },
                // ],
            });

            if (em.name == el.name) {
                if (em.isHighlighted) {
                    em.setOptions({
                        strokeOpacity: 1,
                        // icons: [
                        //     {
                        //         icon: {
                        //             path: "M 0,-1 0,1",
                        //             strokeOpacity: 1,
                        //             scale: 3,
                        //         },
                        //         offset: "0",
                        //         repeat: "20px",
                        //     },
                        // ],
                    });
                } else {
                    em.setOptions({ strokeOpacity: 1 });
                }
            }
        });
    }

    initializeCableOpacity() {
        this.cablePath.forEach((em, i) => {
            em.setOptions({ strokeOpacity: 0.25 });
        });

        this.terrestrialCablePath.forEach((em, i) => {
            em.setOptions({
                strokeOpacity: 0.25,
                // icons: [
                //     {
                //         icon: {
                //             path: "M 0,-1 0,1",
                //             strokeOpacity: 0.25,
                //             scale: 3,
                //         },
                //         offset: "0",
                //         repeat: "20px",
                //     },
                // ],
            });
        });
    }

    displayAllMarkers() {
        const self = this;

        self.googleMarkersArr.forEach((el, i) => {
            el.setVisible(true);
            self.bounds.extend(el.getPosition());
        });

        self.googleUknownMarkersArr.forEach((el, i) => {
            el.setVisible(true);
            self.bounds.extend(el.getPosition());
        });

        self.cablePath.forEach((el, i) => {
            el.setVisible(true);
        });

        self.terrestrialCablePath.forEach((el, i) => {
            el.setVisible(true);
        });

        self.landingPoint.forEach((el, i) => {
            el.setVisible(true);
            self.bounds.extend(el.getPosition());
        });

        $(".-checkbox").removeClass("-disabled");

        self.map.setZoom(self.map.getZoom() - 3);
    }

    resetMarkers() {
        const self = this;

        self.googleMarkersArr.forEach((el, i) => {
            el.setVisible(false);
        });

        self.googleUknownMarkersArr.forEach((el, i) => {
            el.setVisible(false);
        });

        self.cablePath.forEach((el, i) => {
            el.setVisible(false);
        });

        self.terrestrialCablePath.forEach((el, i) => {
            el.setVisible(false);
        });

        self.landingPoint.forEach((el, i) => {
            el.setVisible(false);
        });
    }

    convertDMS(lat, lng) {
        const self = this;

        let latitude = self.toDegreesMinutesAndSeconds(lat);
        let latitudeCardinal = Math.sign(lat) >= 0 ? "N" : "S";

        let longitude = self.toDegreesMinutesAndSeconds(lng);
        let longitudeCardinal = Math.sign(lng) >= 0 ? "E" : "W";

        return (
            latitude +
            " " +
            latitudeCardinal +
            ", " +
            longitude +
            " " +
            longitudeCardinal
        );
    }

    toDegreesMinutesAndSeconds(coordinate) {
        let absolute = Math.abs(coordinate);
        let degrees = Math.floor(absolute);
        let minutesNotTruncated = (absolute - degrees) * 60;
        let minutes = Math.floor(minutesNotTruncated);
        let seconds = Math.floor((minutesNotTruncated - minutes) * 60);

        return degrees + "° " + minutes + "` " + seconds + "``";
    }

    multiGeometryToLatLong(xml) {
        const parser = new DOMParser();

        let xmlDoc = parser.parseFromString(xml, "text/xml");
        let coordArr = [];
        let newCoordArr = [];

        $(xmlDoc)
            .find("LineString")
            .each((i, v) => {
                coordArr = $(v).find("coordinates")[0].innerHTML;
                coordArr = coordArr.split(" ");

                coordArr.forEach((el, i) => {
                    coordArr[i] = el.split(",");
                });

                coordArr.forEach((el, i) => {
                    newCoordArr.push({
                        lng: Number(el[0]),
                        lat: Number(el[1]),
                    });
                });
            });

        return newCoordArr;
    }

    enableMapBtn() {
        $(".-js-explore-map").on("click", function (e) {
            e.preventDefault();

            // window.location.href = window.location.hash.replace('home', 'map');

            window.location.href = "/#/map/";
        });
    }

    killEvents() {
        $("body")
            // .off('click', '.-js-toggle-side-filter')
            .off("click", ".-js-toggle-info")
            .off("click", ".-js-view-company")
            .off("click", ".-js-copy-deeplink");
    }

    findMarker(param, type) {
        const self = this;

        let markerId = "";
        if (type == "marker") {
            markerId = param.replace("marker-", "");

            self.googleMarkersArr.forEach((el, i) => {
                if (el.id == markerId) {
                    google.maps.event.trigger(el, "click");
                }
            });

            self.googleUknownMarkersArr.forEach((el, i) => {
                if (el.id == markerId) {
                    google.maps.event.trigger(el, "click");
                }
            });

            self.cablePath.forEach((el, i) => {
                console.log(el)
              if (el.id == markerId) {
                console.log('LICK')
                google.maps.event.trigger(el, 'click');
              }
            });
        } else if (type == "cable-terrestrial-marker") {
            markerId = param;

            self.googleMarkersArr.forEach((el, i) => {
                if (el.id == markerId) {
                    google.maps.event.trigger(el, "click");
                }
            });

            // self.cablePath.forEach((el, i) => {
            //   if (el.id == markerId) {
            //     console.log('LICK')
            //     google.maps.event.trigger(el, 'click');
            //   }
            // });
        }

        // Set markers visible/hidden on filter
        self.landingPoint.forEach((el, i) => {
            if (el.id == markerId) {
                google.maps.event.trigger(el, "click");
            }
        });
    }

    generateStartPoint() {
        /*
         * Possible start points: North America,South America, Africa, Europe, Asia, Oceania.
         */
        return [
            {
                // Asia
                center: new google.maps.LatLng(15, 121),
                zoom: 4,
            },
            {
                // Oceania
                center: new google.maps.LatLng(-27, 153),
                zoom: 4,
            },
            {
                // North America
                center: new google.maps.LatLng(41, -96),
                zoom: 4,
            },
            {
                // South America
                center: new google.maps.LatLng(-10, -56),
                zoom: 4,
            },
            {
                // Africa
                center: new google.maps.LatLng(-3, 26),
                zoom: 4,
            },
            {
                // Europe
                center: new google.maps.LatLng(48, 19),
                zoom: 4,
            },
        ];
    }
}
